<template>
  <div>
    <!-- hosting-plans START here -->
    <div id="hosting-plans">
      <!-- container START here -->
      <div class="container">
        <!-- plan1 START here -->
        <div class="plan">
          <div class="title">
            <h4>1 Week of Premium Picks</h4>
          </div>
          <div class="content">
            <div class="price">
              <div class="inside">
                ${{ allWeekPrice }}<br />
                <span>/week</span>
              </div>
            </div>
            <ul>
              <li>1 Week</li>
              <li>Premium Access</li>
              <li>In-Depth Analysis</li>
              <li>All Sports Included!</li>
              <li>Picks Emailed or Texted</li>
              <li>And So Much More..</li>
            </ul>
            <purchase-button :package="allWeek" color="grey"></purchase-button>
            <!-- <paypal-button -->
            <!--   :package="allWeek" -->
            <!--   :size="'medium'" -->
            <!--   :color="'gold'" -->
            <!-- ></paypal-button> -->
          </div>
        </div>
        <!-- plan1 END here -->
        <!-- plan2 START here -->
        <div class="plan">
          <div class="title">
            <h4>2 Weeks of Premium Picks</h4>
          </div>
          <div class="content">
            <div class="price">
              <div class="inside">
                ${{ allTwoPrice }}<br />
                <span>/2 weeks</span>
              </div>
            </div>
            <ul>
              <li>2 Weeks</li>
              <li>Premium Access</li>
              <li>In-Depth Analysis</li>
              <li>All Sports Covered</li>
              <li>Picks Emailed or Texted</li>
              <li>And So Much More..</li>
            </ul>
            <purchase-button :package="allTwo" color="yellow"></purchase-button>
            <!-- <paypal-button -->
            <!--   :package="allTwo" -->
            <!--   :size="'medium'" -->
            <!--   :color="'gold'" -->
            <!-- ></paypal-button> -->
          </div>
        </div>
        <!-- plan2 END here -->
        <!-- plan3 START here -->
        <div class="plan no-margin">
          <div class="title">
            <h4>1 Month of Premium Picks</h4>
          </div>
          <div class="content">
            <div class="price">
              <div class="inside1">
                ${{ allMonthPrice }}<br />
                <span>/month</span>
              </div>
            </div>
            <ul>
              <li>Best Value</li>
              <li>Premium Access</li>
              <li>In-Depth Analysis</li>
              <li>All Sports are Covered</li>
              <li>Picks Emailed or Texted</li>
              <li>And So Much More..</li>
            </ul>
            <purchase-button :package="allMonth" color="blue"></purchase-button>
            <!-- <paypal-button -->
            <!--   :package="allMonth" -->
            <!--   :size="'medium'" -->
            <!--   :color="'gold'" -->
            <!-- ></paypal-button> -->
          </div>
        </div>
        <!-- plan3 END here -->
      </div>
      <!-- container END here -->
    </div>
    <!-- hosting-plans  END here -->
    <!-- content START here -->
    <div id="content">
      <!-- container START here -->
      <div class="container">
        <div id="home-colums">
          <!-- colum1 START here -->
          <div class="colum">
            <h3>Sports Picks</h3>
            <p>
              Welcome to Stumpthespread.com. STS is home to expert sports
              betting picks with over a decade in the industry. We offer a daily
              1 unit free pick bet and anaylsis which is enjoyed by thousands of
              our committed members in our free pick area. For those looking to
              take their profits to the next level we recommend trying out an
              All-Sport Premium memberships or a Full-Season sport specific
              package. We offer numerous sports pick packages for our diverse
              cross-section of users from the NFL, NBA, MLB, NHL, NCAAF, and
              NCAAB. We're committed to providing our members with high quality
              matchup analysis and our take on the top leans of the day for
              picks against the spread, straight up, and over/unders. Consider
              joining our team by becoming a free or premium member today
              through a hassle free registration!
            </p>
            <p>
              <router-link :to="{ path: 'packages/all' }" class="big-btn red">
                Learn More
              </router-link>
            </p>
          </div>
          <!-- colum1 END here -->
          <!-- colum2 START here -->
          <div class="colum">
            <h3>Why Us ?</h3>
            <ul id="services-list">
              <li>
                <div class="sprite coins icon"></div>
                High quality premium picks
              </li>
              <li>
                <div class="sprite chart_bar icon"></div>
                {{ count }} members and counting!
              </li>
              <li>
                <div class="sprite iphone icon"></div>
                Access picks on smartphones and tablets
              </li>
              <li>
                <div class="sprite headphone icon"></div>
                Excellent customer service!
              </li>
            </ul>
            <br />
            <adsense
              ad-client="ca-pub-8213113866781504"
              ad-slot="9391510273"
              ad-style="display:inline-block;width:180px;height:150px"
              ad-format="auto"
            >
            </adsense>
          </div>
          <!-- colum2 END here -->
          <!-- colum3 START here -->
          <div class="colum no-margin">
            <h3>Happy Customers</h3>
            <blockquote v-if="testimonial">
              <div class="image sprite me2 alignleft"></div>
              <p>{{ testimonial.content }}</p>
              <div class="sprite testimony-bg"></div>
              <cite>{{ testimonial.author }}, &nbsp;<b>{{
                testimonial.type
              }}</b></cite>
            </blockquote>
            <router-link :to="{ path: '/testimonials' }" class="big-btn red">
              More Testimonials
            </router-link>
            <adsense
              ad-client="ca-pub-8213113866781504"
              ad-slot="9391510273"
              ad-style="display:inline-block;width:180px;height:150px"
              ad-format="auto"
            >
            </adsense>
          </div>
          <!-- colum3 END here -->
        </div>
      </div>
      <!-- container END here -->
    </div>
    <!-- content END here -->
  </div>
</template>

<script>
import PaypalButton from "../components/paypalButton.vue";
import PurchaseButton from "../components/purchaseButton.vue";
import { PACKAGES } from "../constants";
import TestimonialRepository from "../data/testimonial.repository.js";
import AuthRepository from "../data/auth.repository.js";
import Adsense from "../components/adsense.vue";
export default {
  components: {
    purchaseButton: PurchaseButton,
    // paypalButton: PaypalButton,
    adsense: Adsense,
  },
  data() {
    return {
      testimonial: "",
      count: 0,
      posts: "",
    };
  },
  computed: {
    allWeek() {
      return this.$store.getters.package(PACKAGES.ALL_ONE);
    },
    allWeekPrice() {
      return this.allWeek ? this.allWeek.current_price : "";
    },
    allTwo() {
      return this.$store.getters.package(PACKAGES.ALL_TWO);
    },
    allTwoPrice() {
      return this.allTwo ? this.allTwo.current_price : "";
    },
    allMonth() {
      return this.$store.getters.package(PACKAGES.ALL_MONTH);
    },
    allMonthPrice() {
      return this.allMonth ? this.allMonth.current_price : "";
    },
  },
  mounted() {
    TestimonialRepository.getTestimonials(1).then((test) => {
      this.testimonial = test;
    });
    AuthRepository.count().then((res) => {
      this.count = res;
    });
  },
};
</script>

<style lang="css" scoped>
#hosting-plans {
  margin: 0 auto 30px auto;
  width: 960px;
}
#content {
  margin: 0 auto;
  min-width: 960px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?50de6809